import { computed, inject, Injectable } from '@angular/core';
import { DailyRoute } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { EditedStatus, UpdateCustomEditedRouteBody } from 'src/app/pages/custom-route/shared/planner/components/edit-route/interfaces/edit-route.interface';
import { CustomRouteResponseCompleted } from 'src/app/pages/custom-route/interfaces/custom-route.response';
import { catchError, map, of, tap } from 'rxjs';
import { isNotSuccess, validateRoute } from './guards/custom-route.guard';
import dayjs from "dayjs";
import { DetailsService } from 'src/app/pages/new-details/new-details.service';
import { QueryParamsService } from 'src/app/services/query-params.service';
import { RouteDataService } from 'src/app/pages/custom-route/shared/map/services/route-data.service';
import { UpdateCustomRouteData } from 'src/app/fitur-26/pages/home/pages/detail-page/services/update-custom-route-data';
import { WebsocketLaravelReverb } from 'src/app/fitur-26/pages/home/services/websocket-laravel-reverb';
import { Router } from '@angular/router';
import { CHANNEL_ATRIL_PANTALLA_NAME, GO_TO_HOME_PAGE_EVENT } from 'src/app/fitur-26/pages/home/config';

type Result = { is_successful: true } | { is_successful: false; reason: string };

@Injectable({ providedIn: 'root' })

export class AddItemToCustomRouteService {
    private _router = inject(Router);
    private _queryParamsService = inject(QueryParamsService);
    private _customRouteService = inject(CustomRouteService);
    private _updateCustomRoute = inject(UpdateCustomRouteData);
    private _detailsService = inject(DetailsService);
    private _routeDataService = inject(RouteDataService);
    private _websocketLaravelReverbService = inject(WebsocketLaravelReverb);
    

    private itemDetails = computed(() => this._detailsService.itemDetails());
    private currentDayItems = computed(() => this._routeDataService.getCurrentRouteDay());
    private currentDate = computed(() => this._routeDataService.currentDate());
    private _routeToken =  this._customRouteService.token;

    addRecommendedItem(){
        console.log("DEBUG: currentDayRoute", this.currentDayItems())
        const from = this._queryParamsService.get('from');
        const pointId = this._queryParamsService.get('pointId');
        const pointType = this._queryParamsService.get('pointType');
        console.log("DEBUG: from", from)
        console.log("DEBUG: pointId", pointId)
        console.log("DEBUG: pointType", pointType)
        console.log("DEBUG: itemDetails", this.itemDetails())
        if (!this.itemDetails() || !from || !pointId || !pointType) {
            return of({
                is_successful: false,
                reason: 'No se ha seleccionado ningún item'
            })
        }

        const points: any = this.currentDayItems()?.map(item =>
            (item.id === Number(pointId) && item.type === pointType)
                ? {
                    id: this.itemDetails().id,
                    startDate: dayjs(item.startDate).format('YYYY-MM-DDTHH:mm:ss'),
                    title: this.itemDetails().name?.['es'],
                    type: this.itemDetails().type === 'event' ? 'event' : 'point'
                }
                : {
                    id: item.id,
                    startDate: dayjs(item.startDate).format('YYYY-MM-DDTHH:mm:ss'),
                    title: item.title,
                    type: item.type
                }
        );

        const payload = {
            date: dayjs(this.currentDate()).format('YYYY-MM-DD'),
            points,
            token: this._routeToken()
        }

        return this._updateCustomRoute.updateCustomRouteDataDay(payload).pipe(
            tap((res: CustomRouteResponseCompleted | any) => {
                if (res.error)
                    throw new Error(res.error?.[0]?.motive);

                setTimeout(() => {
                    this._websocketLaravelReverbService
                        .sendMessage(
                            CHANNEL_ATRIL_PANTALLA_NAME,
                            GO_TO_HOME_PAGE_EVENT + this._routeToken(),
                            []
                        );
                    
                    this._router.navigate(
                        ['/home/route', this._routeToken()],
                    );
                }, 4000);
            }),
            map((): Result => ({ 
                is_successful: true 
            })),
            catchError((error) => {
                return of<Result>({ 
                    is_successful: false, 
                    reason: error?.message ?? 'No se pudo actualizar la ruta' 
                })
            })
        );

        this._updateCustomRoute.updateCustomRouteDataDay(payload).subscribe(res => {
            console.log("DEBUG: res", res)
        })
    }

    addItem(args: any){
        const route = this._customRouteService.customRouteData();
        const token = this._customRouteService.token();

        const ctx = validateRoute(route, token, args?.day);
        if (isNotSuccess(ctx))
            return of<Result>(ctx);

        const dayIndex = args.day - 1;
        const dayRoute: DailyRoute = route.dailyRoutes[dayIndex];
        const date = dayjs(dayRoute.date)?.format('YYYY-MM-DD');

        const point = {
            id: args?.element_id,
            title: args?.found_name,
            type: args?.type,
            status: EditedStatus.ADDED,
            startDate: new Date(`${date}T${args?.hour}:00`)
        };

        const mappedPoints = dayRoute.points?.map(point => ({
            id: point.id,
            title: point.title,
            type: point?.type,
            startDate: point?.startDate
        }))

        const currentDayPoint = [...mappedPoints, point];
        currentDayPoint.sort((a: any, b: any) => a.startDate - b.startDate);
        const points: any = currentDayPoint?.map(point => ({
            ...point,
            startDate: dayjs(point.startDate)?.format('YYYY-MM-DDTHH:mm:ss')
        }))

        const payload: UpdateCustomEditedRouteBody = { date, token, points };
        return this._customRouteService.updateCustomRouteData(payload).pipe(
            tap((res: CustomRouteResponseCompleted | any) => {
                if (res.error)
                    throw new Error(res.error?.[0]?.motive)
                
                this._customRouteService.updateDailyRoute(res, dayIndex);
            }),
            map((): Result => ({ 
                is_successful: true 
            })),
            catchError((error) => {
                return of<Result>({ 
                    is_successful: false, 
                    reason: error?.message ?? 'No se pudo actualizar la ruta' 
                })
            })
        );
    }
}